// The icons a kid can pick for themselves.
//
// The parent chooses the first one when they add the child; after that it is
// the child's to change. Both pickers read this list, so they cannot drift
// apart.
//
// The server does not hold a copy — it only bounds the value's length — so
// adding an icon here is the whole change.

export interface AvatarGroup {
  label: string;
  emoji: string[];
}

export const AVATAR_GROUPS: AvatarGroup[] = [
  {
    label: "Animals",
    emoji: ["🦊", "🐢", "🐙", "🦄", "🐝", "🐼", "🐸", "🦁", "🐨", "🦖"],
  },
  { label: "Space", emoji: ["🚀", "⭐️", "🌙", "☄️", "🛸", "🪐"] },
  { label: "Snacks", emoji: ["🍕", "🍩", "🍦", "🍓", "🥑", "🌮"] },
  { label: "Play", emoji: ["⚽️", "🏀", "🎸", "🎮", "🛹", "🎨"] },
  { label: "Fun", emoji: ["🌈", "⚡️", "🔥", "🎈", "👑", "🦩"] },
];

/** What the avatar picker starts on when a parent adds a child. */
export const DEFAULT_AVATAR = "🦊";

/** Stands in for a child whose avatar was never set. */
export const FALLBACK_AVATAR = "🙂";
